// extracted by mini-css-extract-plugin
export default {"bmisubmissionCard":"styles_bmisubmissionCard__w40RW","bmisubmissionIcon":"styles_bmisubmissionIcon__vOu+N"};